import { createSlice } from "@reduxjs/toolkit";
import { verifyBvn } from "./api";

const initialState = {
  response: {},
  loading: false,
  error: null,
};

const verifyBvnSlice = createSlice({
  name: "verifyBvn",
  initialState,

  reducers: {
    clearVerifyBvnResponse: () => initialState,
  },

  extraReducers: (builder) => {
    builder.addCase(verifyBvn.pending, (state) => {
      state.loading = true;
      state.error = null;
    });

    builder.addCase(verifyBvn.fulfilled, (state, action) => {
      state.response = action.payload;
      state.loading = false;
    });

    builder.addCase(verifyBvn.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export const { clearVerifyBvnResponse } = verifyBvnSlice.actions;

export default verifyBvnSlice.reducer;
